import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import cns from 'classnames';
import Image from '../../components/Image';
import TextInput from '../../components/formComponents/inputs/TextInput';
import RichTextDisplay from '../../components/RichTextDisplay';

export default class ChooseManySlideOptions extends PureComponent {
    static propTypes = {
        handleOptionSelect: PropTypes.func,
        onOtherOptionChange: PropTypes.func,
        otherTextEnabled: PropTypes.bool,
        completedData: PropTypes.shape({
            data: PropTypes.array
        }),
        includeChoiceLabels: PropTypes.bool,
        isWelcomeWorkspace: PropTypes.bool,
        displayType: PropTypes.string,
        options: PropTypes.arrayOf(PropTypes.object),
        selectChoice: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
        currentUser: PropTypes.object,
        nextSectionName: PropTypes.string,
    };

    _isSelected = (option) => {
        const { selectChoice } = this.props;
        for (let i = 0; i < selectChoice.length; i += 1) {
            if (selectChoice[i].includes(option.choice)) {
                return true;
            }
        }
        return false;
    };

    _renderTextOptions = (options) => {
        const {
            includeChoiceLabels,
            handleOptionSelect,
            completedData: { data = [] },
            onOtherOptionChange,
            otherTextEnabled = true,
            currentUser,
            nextSectionName,
        } = this.props;
        let otherTextValue = '';
        (data || []).forEach((selectedOption) => {
            if (selectedOption && selectedOption.split('::::').length > 1) {
                ({ 1: otherTextValue } = selectedOption.split('::::'));
            }
        });
        return options.map((option, index) => {
            const sanitizedData = option.label.replace(/<\/?p>/g, "")
            const isSelected = this._isSelected(option);
            const onClick = (e) => handleOptionSelect(e, option.choice);
            const otherOnClick = (e) => handleOptionSelect(e, option.choice, otherTextEnabled);
            const className = cns('chooseSlide-option', {
                selected: isSelected,
                'include-score': includeChoiceLabels
            });
            let style = {};
            if (data && data.length) {
                style = {};
            }

            if (option.isOther && !option.disableOtherTextBox) {
                return (
                    <div className={'other-option-wrapper'}>
                        <div style={style} onClick={otherOnClick} className={className} key={index}>
                            <div
                                className={'chooseManySlide-optionRadio'}
                                onKeyPress={otherOnClick}
                                value={otherTextValue}
                                tabIndex={'0'}
                            />
                            <div className={'chooseSlide-other-option-label'}>{sanitizedData}</div>
                        </div>
                        {isSelected && otherTextEnabled && (
                            <TextInput
                                componentClass={'textarea'}
                                rows={2}
                                className={'other-option-text-area'}
                                type={'text'}
                                value={otherTextValue}
                                placeholder={''}
                                onChange={(e) => {
                                    onOtherOptionChange(e, option.choice);
                                }}
                            />
                        )}
                    </div>
                );
            }
            return (
                <div style={style} className={className} key={index} onClick={onClick}>
                    <div className={'chooseManySlide-optionRadio'} onKeyPress={onClick} tabIndex={'0'} />
                    <RichTextDisplay
                        className={'chooseSlide-optionLabel'}
                        htmlToDisplay={sanitizedData}
                        currentUser={currentUser}
                        nextSectionName={nextSectionName}
                    />
                </div>
            );
        });
    };

    _renderImageOptions = (options) => {
        const {
            includeChoiceLabels,
            handleOptionSelect,
            selectChoice,
            completedData: { data = [] },
            isWelcomeWorkspace,
            currentUser,
            nextSectionName,
        } = this.props;
        const imagesPerRow = isWelcomeWorkspace ? 4 : 3;
        const elementsToRender = [];
        let tempOptions = [];
        options.forEach((option, index) => {
            const isSelected = this._isSelected(option);
            const onClick = (e) => handleOptionSelect(e, option.choice);
            let style = { animation: `fadeIn ${0.25 * (index + 1)}s ease-in` };
            if (data && data.length) {
                style = {};
            }
            const className = cns('chooseSlide-option image-option col-12 col-md-3', {
                unselected: selectChoice && selectChoice.length && !isSelected,
                selected: isSelected,
                'include-score': includeChoiceLabels
            });
            tempOptions.push(
                <div style={style} className={className} key={index} onClick={onClick} onKeyPress={onClick}>
                    <div className={'chooseSlide-optionImage'} tabIndex={'0'}>
                        <Image src={option.image} dimension={{ h: 200, w: 200 }} alt={`Option ${index}`} />
                    </div>
                    <div className={'choose-radio-container'}>
                        <div className={'chooseManySlide-optionRadio'} tabIndex={'0'} />
                    </div>
                    <RichTextDisplay
                        className={'chooseSlide-optionLabel'}
                        htmlToDisplay={option.label}
                        currentUser={currentUser}
                        nextSectionName={nextSectionName}
                    />
                </div>
            );

            if (tempOptions.length === imagesPerRow || index === options.length - 1) {
                elementsToRender.push(<div className={'choose-image-row row'}>{tempOptions}</div>);
                tempOptions = [];
            }
        });

        return elementsToRender;
    };

    _renderBoxOptions = (options) => {
        const {
            includeChoiceLabels,
            handleOptionSelect,
            onOtherOptionChange,
            completedData: { data = [] },
            otherTextEnabled = true,
            currentUser,
            nextSectionName,
        } = this.props;

        let otherTextValue = '';

        let otherOptionComponent = null;
        (data || []).forEach((selectedOption) => {
            if (selectedOption && selectedOption.split('::::').length > 1) {
                ({ 1: otherTextValue } = selectedOption.split('::::'));
            }
        });
        const boxOptions = options.map((option, index) => {
            const isSelected = this._isSelected(option);
            const onClick = (e) => handleOptionSelect(e, option.choice);
            const className = cns('chooseSlide-option box-option', {
                selected: isSelected,
                'include-score': includeChoiceLabels
            });
            const style = { animation: `fadeIn ${0.25 * (index + 1)}s ease-in` };

            if (option.isOther && !option.disableOtherTextBox) {
                otherOptionComponent = (
                    <>
                        <div>
                            {isSelected && otherTextEnabled && (
                                <TextInput
                                    componentClass={'textarea'}
                                    rows={2}
                                    className={'other-option-text-area other-option-text-area-box'}
                                    type={'text'}
                                    value={otherTextValue}
                                    placeholder={''}
                                    onChange={(e) => {
                                        onOtherOptionChange(e, option.choice);
                                    }}
                                />
                            )}
                        </div>
                    </>
                );
            }
            return (
                <div style={style} className={className} key={index} onClick={onClick}>
                    <RichTextDisplay
                        className={'chooseSlide-optionLabel'}
                        htmlToDisplay={option.label}
                        currentUser={currentUser}
                        nextSectionName={nextSectionName}
                    />
                </div>
            );
        });

        return (
            <>
                <div className={'box-options-container'}>{boxOptions}</div>
                <div>{otherOptionComponent}</div>
            </>
        );
    };

    _renderAnswerOptions = (displayType) => {
        const { options } = this.props;
        if (displayType === 'image') {
            return this._renderImageOptions(options);
        }
        if (displayType === 'radio') {
            return this._renderTextOptions(options);
        }
        if (displayType === 'box') {
            return this._renderBoxOptions(options);
        }
        return {};
    };

    render() {
        const { displayType } = this.props;
        return this._renderAnswerOptions(displayType);
    }
}
